import { Directive, HostListener, Input } from '@angular/core';
import { GtmTracking } from '../services/gtm.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[trackable]',
})
export class ClickEventDirective {
  @Input() trackable!: string;

  constructor(private gtmTracking: GtmTracking) {}

  @HostListener('click')
  sendGtmEvent() {
    this.gtmTracking.clickEvent(this.trackable);
  }
}
